<template>
  <div>
    <div class="uk-background-cover uk-light uk-flex BannerItem" uk-parallax="bgy: -200;"
         :style="{'backgroundImage': 'url('+bannerUrl+')'}">
    </div>
    <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s HeaderCon">
      <h1 class="uk-text-center uk-text-middle AppTitle Title" data-aos="zoom-in" data-aos-delay="100">{{title}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerComponent',
  props: ['bannerUrl', 'title']
}
</script>

<style scoped>
  .BannerItem {
    background-color: #00000033;
    background-blend-mode: color;
    height: 56.15vw;
    max-height: 600px;
  }

  .Title {
    padding-top: 35px;
    font-family: 'Kaushan Script', cursive !important;
  }
</style>
